import { transform } from "~/features/search/api/fetchAutosuggestions";
import { resolveApiUrl } from "~/utils/url/urlResolver";

export function fetchProductSuggestionsForPreview(query: string, abortSignal: AbortSignal) {
  return fetch(getUrl(query), { credentials: "same-origin", signal: abortSignal })
    .then((res) => {
      if (res.redirected) {
        window.location.reload();
      }
      return res.json();
    })
    .then(transform);
}

const apiUrl = resolveApiUrl("/search/quick-search");

function getUrl(query: string) {
  const searchParams = new URLSearchParams();
  searchParams.set("site", "schaeffler");

  searchParams.set("q", query);
  searchParams.set("text", query);

  return apiUrl + "?" + searchParams.toString();
}
